import {media} from 'style/media';
import {createGlobalStyle} from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  ${media.fourK`
    html { font-size: 100%; }
  `}

  ${media.desktop`
    html { font-size: 85%; }
  `}

  ${media.laptop`
    html { font-size: 80%; }
  `}

  ${media.tablet`
    html { font-size: 70%; }
  `}

  ${media.mobileL`
    html { font-size: 67.5%; }
  `}

  ${media.mobileM`
    html { font-size: 65%; }
  `}

  ${media.mobileS`
    html { font-size: 62.5%; }
  `}

  body {
    font-family: 'Roboto', sans-serif;
    font-size: 1.6rem;
  }

  body, button, input, option, textarea, select {
    outline-color: #3884ff;
  }

  input, option, select {
    font-family: inherit;
  }
`;
